import React from "react";
import Hero from "../components/ride/Hero";
import MainLayout from "../components/MainLayout";
import Description from "../components/ride/Description";
import { Container } from "react-bootstrap";
import Steps from "../components/ride/steps/Steps";

const Ride = () => {
  return (
    <MainLayout>
      <Hero />
      <Container>
        <Description />
        <Steps />
      </Container>
    </MainLayout>
  );
};

export default Ride;
